import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d72d1bb4"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=d72d1bb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports